import { render, staticRenderFns } from "./Siporoks.vue?vue&type=template&id=08f3dc03&scoped=true&"
import script from "./Siporoks.vue?vue&type=script&lang=js&"
export * from "./Siporoks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f3dc03",
  null
  
)

export default component.exports